import { SegmentType } from 'modules/Search/constants';

// user login validations
export const USER_CODE_LENGTH = 6;
export const PASSCODE_LENGTH = 4;

// Segment
export const EQUITIES_SEGMENT = [SegmentType.BSE_EQ, SegmentType.NSE_EQ];
export const OPTIONS_SEGMENT = [SegmentType.NSE_FO, SegmentType.BSE_FO];
export const CURRENCY_SEGMENT = [SegmentType.NCD_FO, SegmentType.BCD_FO];
export const COMMODITY_SEGMENT = [
  SegmentType.MCX_FO, SegmentType.NSE_COM, SegmentType.MCX_COM,
];
export const DERIVATIVES_SEGMENT = [...OPTIONS_SEGMENT, ...CURRENCY_SEGMENT];
export const SECURITIES_SEGMENT = [...EQUITIES_SEGMENT, ...DERIVATIVES_SEGMENT];
export const FNO_SEGMENT = [...DERIVATIVES_SEGMENT, ...COMMODITY_SEGMENT];
